export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar Pallet"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver al contenedor"])},
          "add_package_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agregar paquete"])},
          "new_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])},
          "save_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])}
        }
      }
    }
  })
}